import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-enable-debt-collection',
  templateUrl: './enable-debt-collection.component.html',
  styleUrl: './enable-debt-collection.component.scss'
})
export class EnableDebtCollectionComponent {
extra_data!: any;
  floating_modal: boolean = false;
  doctor_debt_type : any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  doctor_id: any;

  constructor(private bsModalRef: BsModalRef,
    private main: MainService,
    private _api: ApiService,
    private shared: SharedService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.doctor_debt_type = this.main.doctor_profile.doctor_debt_type ? this.main.doctor_profile.doctor_debt_type : '';
    this.doctor_id = this.main.doctor_profile.doctor_id;
  }
  closeModal() {
    console.log('Modal closed');
    this.bsModalRef.hide();
  }
  updatedebttype(type: any){
    const body = {
      doctor_id: this.doctor_id,
      debt_type: this.doctor_debt_type == 1 || this.doctor_debt_type == 2 && this.doctor_debt_type != type ? 3 : type
    }
    this._api.api(body, '/profile/update_debt_type', 'post').subscribe((resp) => {
      if(!resp.is_error){
        this.shared.customPopups('updated successfully', 0)
        this.passEntry.emit({ success: true });
        this.main.accessTokenLogin();
        this.router.navigate(['/debt-type-enabled'], {
          queryParams: { debt_type: type,}
        });
        this.bsModalRef.hide();
      } else{
        this.shared.customPopups('Something went wrong' , 1)
        this.bsModalRef.hide();
      }
    })
  }
}
